export function nextDispatchDate(now, locale) {
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 12);
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(tomorrow);
}
if (typeof document !== 'undefined' && !window.essentaeDispatchDates) {
  window.essentaeDispatchDates = true;
  const update = () => document.querySelectorAll('[data-essentae-dispatch-date]').forEach(el => {
    const locale = el.dataset.locale || document.documentElement.lang;
    if (!locale) return;
    try { el.textContent = nextDispatchDate(new Date(), locale); } catch (_) { /* Keep localized tomorrow fallback. */ }
  });
  update();
  setInterval(update, 60000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
}
